import React from "react";
import { useStylesGeneral } from '../../styles/StyleComponents';
import BotonCS from '../../common/ComponentesCS/BotonCS';
import BotonUploadCloud from '../../common/ComponentesCS/BotonUploadCloudCS';
import Divider from '@material-ui/core/Divider';
import "../../styles/site.css";

function Otros() {
  const classes = useStylesGeneral();
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (event) => {
    setLoading(true);
    setLoading(false);
  }

  return (<>
    <label className='tituloSeccion'>Botones</label>
    <div className={classes.root}>
      <Divider style={{ marginBottom: 17, marginTop: 17 }} />
      <BotonCS onClick={handleSubmit} loading={loading} title={"Ingresar"} color={'#FFA100'} />
      <Divider style={{ marginBottom: 17, marginTop: 17 }} />
      <BotonUploadCloud></BotonUploadCloud>
      <Divider style={{ marginBottom: 17, marginTop: 17 }} />
    </div>
  </>)
}

export default React.memo(Otros);
